export class PostCommentInput {
  auditProgramId: string;
  auditItemId: string;
  postTo: string;
  postCC: string;
  subject: string;
  bodyPlainText: string;
  bodyHtmlText: string;
  siteId: number;
}
